import { createFileRoute, Link, Outlet, useRouterState } from "@tanstack/react-router";
import { Layout } from "antd";
import { useSistemaStore } from "features/sistema/store";
import { Copyright } from "layout/components/Copyright";
import style from "./style.module.scss";

export const Route = createFileRoute("/auth")({
	component: AuthLayout,
});

const topBarInfo = {
	"/auth/login": {
		t: "Ainda não tem conta?",
		d: "Criar agora",
		l: "/auth/cadastro",
	},
	"/auth/cadastro": {
		t: "Já possui uma conta?",
		d: "Entre",
		l: "/auth/login",
	},
};

function AuthLayout() {
	const route = useRouterState().location.pathname;
	const sistema = useSistemaStore((s) => s.sistema);

	return (
		<Layout>
			<Layout.Content>
				<div
					className="w-full min-h-[100vh] flex flex-col items-center bg-no-repeat bg-cover bg-center shrink-0 shadow-md"
					style={{
						backgroundImage: sistema?.sis_banner_fundo ? `url(${sistema.sis_banner_fundo})` : "url(resources/images/fundo_login.jpg)",
					}}
				>
					<div className="h-16 border-b-2 border-solid border-gray-100 bg-white mb-[7vh] flex flex-row items-center justify-between p-7 w-full">
						<div className={style.logoContainer}>
							<div className={style.logo}>
								<Link to="/auth/login">
									<img src="resources/images/logo.svg" className="mr-2" alt={sistema?.sis_nome_sistema} />
								</Link>
								<div style={{ color: sistema?.layout.sic_cor_sistema_nome }} className={style.name}>
									{sistema?.sis_nome_sistema}
								</div>
							</div>
						</div>

						<div className="d-none d-sm-block">
							<span className="mr-2">{topBarInfo[route]?.t}</span>
							<Link to={topBarInfo[route]?.l} className="text-base kit__utils__link">
								{topBarInfo[route]?.d}
							</Link>
						</div>
					</div>

					<div className={style.containerInner}>
						<Outlet />
					</div>

					<Copyright />
				</div>
			</Layout.Content>
		</Layout>
	);
}
